import OPushSegmentType from './index.vue';

OPushSegmentType.install = app => {
  app.component(OPushSegmentType.name, OPushSegmentType);
};

export default OPushSegmentType;
